import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef } from "react";
import React, { useEffect, useState, useMemo } from "react";
import { toast } from "react-toastify";
import SimpleSelect from "../../common/form/SimpleSelect";
import SimpleInput from "../../common/form/SimpleInput";
import { uploadToS3 } from "../../../../functions/uploadToS3";
import { Productfilters } from "../../../../mock/DropdownOptions";
import { updateProduct } from "../../../../service/DashboardService";
import { getProductById } from "../../../../service/MainService";

export default function UpdateProductData({ open, setOpen, editProductId }) {
  const cancelButtonRef = useRef(null);
  const [productData, setProductData] = useState({
    ProductName: "",
    Image1Main: "",
    PdfFile: "",
    Properties: "",
    Application: "",
    Materials: "",
    PrdtCategory: "",
    SubCategory: "",
    Certification: "",
  });
  const [SubcategoryOptions, setSubcategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  useEffect(() => {
    if (open && editProductId) {
      getProductDetails(editProductId);
    }
  }, [open, editProductId]);

  const getProductDetails = async (productId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await getProductById(productId, token);
      setProductData({
        ProductName: response.ProductName,
        Properties: response.Properties,
        Application: response.Application,
        Materials: response.Materials,
        PrdtCategory: response.PrdtCategory,
        SubCategory: response.SubCategory,
        Certification: response.Certification,
        Image1Main: response.Image1Main,
        PdfFile: response.PdfFile,
      });
      setSelectedCategory(response.PrdtCategory);
      setSubcategoryOptions(response.SubCategoryOptions || []);
    } catch (error) {
      console.error("Error fetching product details:", error);
    }
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    try {
      const token = localStorage.getItem("accessToken");
      const userId = parseInt(localStorage.getItem("userId"), 10);
      const productId = editProductId
      const response = await updateProduct(productData, userId, token, productId);
      if (response) {
        toast.success("Product Updated successfully");
        setOpen(false);
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error(error.message || "Something went wrong");
    }
  };

  const handleMainImageUpload = async (event) => {
    const file = event.currentTarget.files[0];
    setProductData({ ...productData, Image1Main: file.name }); 
    await uploadToS3(file, setProductData, "Image1Main");
  };
  
  const handlePdfUpload = async (event) => {
    const file = event.currentTarget.files[0];
    setProductData({ ...productData, PdfFile: file.name });
    await uploadToS3(file, setProductData, "PdfFile");
  };
  

  const categoryOptions = useMemo(() =>
    Productfilters.find(
      (filter) => filter.id === "type" && filter.name === "Type"
    )?.options || [], []);

  const propertiesOptions = useMemo(() =>
    Productfilters.find(
      (filter) => filter.id === "Properties" && filter.name === "Properties"
    )?.options || [], []);

  const materialOptions = useMemo(() =>
    Productfilters.find(
      (filter) => filter.id === "Materials" && filter.name === "Materials"
    )?.options || [], []);

  const applicationOptions = useMemo(() =>
    Productfilters.find(
      (filter) => filter.id === "Application" && filter.name === "Application"
    )?.options || [], []);

  const certificationOptions = useMemo(() =>
    Productfilters.find(
      (filter) =>
        filter.id === "Certification" && filter.name === "Certification"
    )?.options || [], []);

  useEffect(() => {
    const selectedCategoryOptions = categoryOptions.find(
      (option) => option.value === selectedCategory
    );

    if (selectedCategoryOptions) {
      setSubcategoryOptions(selectedCategoryOptions.subcategories || []);
    } else {
      setSubcategoryOptions([]);
    }
  }, [selectedCategory, categoryOptions]);

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setProductData({
      ...productData,
      PrdtCategory: event.target.value,
    });
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-6xl">
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div>
                    <h1>Update Product Info</h1>
                    <form onSubmit={handleUpdate}>
                      <div className=" pb-12">
                        <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                          <div className="sm:col-span-2">
                            <SimpleInput
                              type={"text"}
                              label={"Product Name"}
                              value={productData.ProductName}
                              onChange={(e) =>
                                setProductData({
                                  ...productData,
                                  ProductName: e.target.value,
                                })
                              }
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div className="border-b border-gray-900/10 pb-12">
                        <div className=" grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                          <div className="sm:col-span-2">
                            <SimpleSelect
                              type={"text"}
                              title={"Product Category"}
                              selectoptions={categoryOptions}
                              value={selectedCategory}
                              onChange={handleCategoryChange}
                              required
                            />
                          </div>
                          <div className="sm:col-span-2">
                            <SimpleSelect
                              type={"text"}
                              title={"Product SubCategory"}
                              selectoptions={SubcategoryOptions}
                              value={productData.SubCategory}
                              onChange={(e) =>
                                setProductData({
                                  ...productData,
                                  SubCategory: e.target.value,
                                })
                              }
                              disabled={!selectedCategory}
                              required
                            />
                          </div>
                          <div className="sm:col-span-2">
                            <SimpleSelect
                              type={"text"}
                              title={"Properties"}
                              selectoptions={propertiesOptions}
                              value={productData.Properties}
                              onChange={(e) =>
                                setProductData({
                                  ...productData,
                                  Properties: e.target.value,
                                })
                              }
                              required
                            />
                          </div>
                          <div className="sm:col-span-2">
                            <SimpleSelect
                              type={"text"}
                              title={"Application"}
                              selectoptions={applicationOptions}
                              value={productData.Application}
                              onChange={(e) =>
                                setProductData({
                                  ...productData,
                                  Application: e.target.value,
                                })
                              }
                              required
                            />
                          </div>

                          <div className="sm:col-span-2">
                            <SimpleSelect
                              type={"text"}
                              title={"Materials"}
                              selectoptions={materialOptions}
                              value={productData.Materials}
                              onChange={(e) =>
                                setProductData({
                                  ...productData,
                                  Materials: e.target.value,
                                })
                              }
                              required
                            />
                          </div>

                          <div className="sm:col-span-2">
                            <SimpleSelect
                              type={"text"}
                              title={"Certification"}
                              selectoptions={certificationOptions}
                              value={productData.Certification}
                              onChange={(e) =>
                                setProductData({
                                  ...productData,
                                  Certification: e.target.value,
                                })
                              }
                              required
                            />
                          </div>

                          <div className="col-span-2">
                            <label
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              for="multiple_files"
                            >
                              Upload main image{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <div className="flex items-center">
                              <input
                                className="hidden"
                                id="multiple_files"
                                type="file"
                                multiple
                                onChange={handleMainImageUpload}
                              />
                              <span className="mr-2">
                                {productData.Image1Main
                                  ? productData.Image1Main
                                  : "No file selected"}
                              </span>
                              <label
                                for="multiple_files"
                                className="cursor-pointer text-blue-500 dark:text-blue-400"
                              >
                                {productData.Image1Main ? "Change" : "Upload"}
                              </label>
                            </div>

                            <p
                              className="mt-1 text-xs text-gray-800 dark:text-gray-300 float-right"
                              id="file_input_help"
                            >
                              {" "}
                              .png, .jpg, .jpeg.
                            </p>
                          </div>

                          <div className="sm:col-span-2">
                            <label
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              htmlFor="pdf_file"
                            >
                              Upload Product Specifications{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <div className="flex items-center">
                              <input
                                className="hidden"
                                id="pdf_file"
                                type="file"
                                accept="application/pdf"
                                onChange={handlePdfUpload}
                              />
                              <span className="mr-2">
                                {productData.PdfFile
                                  ? productData.PdfFile
                                  : "No file selected"}
                              </span>
                              <label
                                htmlFor="pdf_file"
                                className="cursor-pointer text-blue-500 dark:text-blue-400"
                              >
                                {productData.PdfFile ? "Change" : "Upload"}
                              </label>
                            </div>
                            <p
                              className="mt-1 text-xs text-gray-800 dark:text-gray-300 float-right"
                              id="pdf_file_input_help"
                            >
                              PDF (MAX. 5MB).
                            </p>
                          </div> 
                        </div>
                      </div>
                      <div className="mt-6 flex items-center justify-end gap-x-6">
                        <button
                          type="submit"
                          className="flex items-center gap-2 text-gray-900 bg-gradient-to-r from-cyan-200 via-cyan-300 to-cyan-400 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                        >
                          Update
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
